import axios from "axios";
import { ENDPOINT } from "constants/environment";
import { consoleLog } from "helpers";
import { encryptData } from "helpers";
import { decryptData } from "helpers";
import { getHeaderConfig } from "helpers";

export const getPromptsAPI = async (payload, isLoading, accessJWT) => {
  try {
    isLoading(true);
    const config = getHeaderConfig(null, accessJWT);

    const body = {
      skip: payload.pageIndex + 1,
      limit: payload.limit,
    };

    const response = await axios.post(
      `${ENDPOINT}/app/v1/systemprompt/search`,
      encryptData(body),
      config
    );

    const parsedResponseData = JSON.parse(decryptData(response?.data));
    if (parsedResponseData && parsedResponseData?.statusCode === 200) {
      if (isLoading) isLoading(false);

      return parsedResponseData?.data;
    }
    if (isLoading) isLoading(false);
    isLoading(false);
    throw Error;
  } catch (error) {
    isLoading(false);
    console.error("Error fetching data:", error);
    return null;
  }
};

export const getFilterPromptsAPI = async (payload, setIsLoading, accessJWT) => {
  try {
    setIsLoading(true);
    const config = getHeaderConfig(null, accessJWT);
    consoleLog([payload, "payload"]);

    const body = {
      skip: payload.pageIndex + 1,
      limit: payload.limit,
      searchQuery: payload.searchQuery,
    };

    const response = await axios.post(
      `${ENDPOINT}/app/v1/systemprompt/search`,
      encryptData(body),
      config
    );

    const decrypted = decryptData(response?.data);
    consoleLog(["Decrypted FilterWebPrompts response:", decrypted]);

    const parsedResponseData = JSON.parse(decrypted);
    setIsLoading(false);

    if (parsedResponseData?.statusCode === 200) {
      return {
        data: parsedResponseData?.data.data,
        totalPages: parsedResponseData.data.pagination?.totalPages,
      };
    }

    throw new Error("Error fetching data");
  } catch (error) {
    setIsLoading(false);
    console.error("Error fetching data:", error);
    return { data: [], totalPages: 0 };
  }
};

export const getPreviewSystemPromptsAPI = async (
  isLoading,
  accessJWT,
  systemPromptId = ""
) => {
  const body = {
    id: systemPromptId || "",
  };
  try {
    // https://api-test.zenvoya.ai/app/prompt/?id=ec8865b1-a5f6-4485-9a36-e8f67e051f06
    const URL = systemPromptId
      ? `${ENDPOINT}/app/v1/prompts`
      : `${ENDPOINT}/app/v1/systemprompt`;

    if (isLoading) isLoading(true);
    const config = getHeaderConfig(null, accessJWT);
    const response = await axios.post(
      URL,
      systemPromptId ? encryptData(body) : "",
      config
    );
    const parsedResponseData = JSON.parse(decryptData(response?.data));
    consoleLog([parsedResponseData, "response"]);
    if (parsedResponseData && parsedResponseData?.statusCode === 200) {
      if (isLoading) isLoading(false);
      consoleLog([parsedResponseData, "response"]);
      return parsedResponseData?.data;
    }
    if (isLoading) isLoading(false);
    isLoading(false);
    throw Error;
  } catch (error) {
    isLoading(false);
    console.error("Error fetching data:", error);
    return null;
  }
};

export const createOrUpdateSystemPromptsAPI = async (
  args,
  isLoading,
  accessJWT
) => {
  const API_URL = `${ENDPOINT}/app/v1/systemprompt`;
  try {
    if (isLoading) isLoading(true);
    const config = getHeaderConfig(null, accessJWT);
    const response = args?.id
      ? await axios.put(API_URL, encryptData({ ...args }), config)
      : await axios.post(API_URL, encryptData({ ...args }), config);

    const parsedResponseData = JSON.parse(decryptData(response?.data));

    if (parsedResponseData && parsedResponseData?.statusCode === 200) {
      if (isLoading) isLoading(false);
      return parsedResponseData?.data;
    }

    if (isLoading) isLoading(false);
    throw new Error(parsedResponseData?.message || "Unknown server error");
  } catch (error) {
    if (isLoading) isLoading(false);

    throw error;
  }
};

export const deleteSystemPromptsAPI = async (args, isLoading, accessJWT) => {
  const API_URL = `${ENDPOINT}/app/v1/systemprompt?id=${args.id}`;
  try {
    if (isLoading) isLoading(true);
    const config = getHeaderConfig(null, accessJWT);
    const response = await axios.delete(API_URL, config);
    const parsedResponseData = JSON.parse(decryptData(response?.data));
    if (parsedResponseData) {
      if (isLoading) isLoading(false);
      return parsedResponseData;
    }
    if (isLoading) isLoading(false);
    isLoading(false);
    throw Error;
  } catch (error) {
    isLoading(false);
    console.error("Error deleting system prompt:", error);
    return null;
  }
};
